import http from '../utils/http';
import i18n from '@/main';

const baseRoute = '/operacao/dashboard-monitoramento';

export default {
    buscarHistoricos(body) {
        return http.post({
            url: baseRoute + '/',
            data: body,
            lockScreen: false,
            lockMessage: i18n.t(
                'mensagens.sistema.buscandoDadosDeMonitoramentoDasOperacoes'
            )
        });
    },
    buscarRelatorios(body) {
        return http.post({
            url: baseRoute + '/relatorio/por-historico-id',
            data: body,
            lockScreen: false,
            lockMessage: i18n.t(
                'mensagens.sistema.buscandoDetalhesDeMonitoramentosDasOperacoes'
            )
        });
    },
    buscarTabelaBaseDados(body) {
        return http.post({
            url: baseRoute + '/buscarTabelaBaseDados',
            data: body,
            lockScreen: false,
            lockMessage: i18n.t(
                'mensagens.sistema.buscandoDadosDeMonitoramentoDasOperacoes'
            )
        });
    }
};
